import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, } from 'react';
const SessionContext = createContext(null);
export function SessionProvider({ children, session = getSession() }) {
    return _jsx(SessionContext.Provider, { value: session, children: children });
}
export function useSession() {
    const session = useContext(SessionContext);
    if (!session) {
        throw new Error('The useSession hook must be used within a SessionProvider.');
    }
    return session;
}
export function withSessionProvider(WrappedComponent) {
    return function WithSessionComponent(props) {
        return (_jsx(SessionProvider, { children: _jsx(WrappedComponent, { ...props }) }));
    };
}
export function getSession() {
    return globalThis.window?.__dashboardSession;
}
export class InvalidSessionError extends Error {
    constructor(message) {
        super(`Invalid session type: ${message}`);
    }
}
export function isPersonEmploymentSession(session) {
    return typeof session.merchantToken === 'string' && typeof session.employmentToken === 'string' && session.employment !== undefined;
}
export function usePersonEmploymentSession() {
    const session = useSession();
    if (!isPersonEmploymentSession(session)) {
        throw new InvalidSessionError('Expected a PersonEmploymentSession');
    }
    return session;
}
export function getPersonEmploymentSession() {
    const session = getSession();
    if (!isPersonEmploymentSession(session)) {
        throw new InvalidSessionError('Expected a PersonEmploymentSession');
    }
    return session;
}
